// @core/api/endpoints/document/create_category.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CategoryResponse,
  CreateCategoryRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Create category
 * Creates a new document category for organizing documents. Categories can be nested.
 */
export async function CreateCategory(
  data: CreateCategoryRequest,
  options?: RequestOptions
): Promise<CategoryResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/document-categories`;
  const requestOptions = options;
  return client.post<CategoryResponse>(requestPath, data, requestOptions);
}
